import { reducer as form } from 'redux-form';
import CombineReducers from './combineReducers';
import auth from './auth';
import orders from './orders';
import locations from './locations';
import nav from './nav';
import companies from './companies';
import print from './print';
import user from './user';
import fleet from './fleet';
import manifests from './manifests';
import drivers from './drivers';
import users from './users';

const appReducer = CombineReducers({
    form,
    auth,
    nav,
    orders,
    locations,
    companies,
    print,
    user,
    fleet,
    manifests,
    drivers,
    users,
});

const rootReducer = (state, action) => {
    if (action.type === `user/USER_LOGOUT`) {
        delete state.auth.profile;
        delete state.user;
        delete state.locations;
    }
    return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js